<template>
  <div class="row">
      <div id="tableandMapa" class="flex md12 xs12">
        <sp-360-panel :title='this.tituloDashboard + " - " + this.munAtual'
        :tooltipOptions="tooltipOptions"
        :footerComplementar="footerTabelaMapa"
        :footerText="footerText">
            <div id="flex-box">
                <sp-map v-on:regiaoClicada="filtrarPorRegiao($event)" ref="mapa" id="mapaSP" />
                    <div id="tabelaSolicitacoesRegiao">
                        <div id="divFiltroTempo">
                          <multiselect
                              id="selectSegmentoTemporal"
                              name="selectTemporal"
                              :placeholder="$t('mainDashboard.filterTablePlaceholder')"
                              :value="corteTemporalEscolhido"
                              :options="corteTemporal"
                              :searchable="false"
                              :close-on-select="true"
                              :show-labels="false"
                              :allowEmpty="false"
                              @input="updatesub"

                          />
                        </div>
                        <div class="flex xs12 sm6 ">
                          <va-input class=""
                            v-model="termoBuscaSituacao"
                            placeholder="Pesquisar"
                            removable
                            @input="buscaTermoSituacao"
                          >
                            <va-icon name="fa fa-search" slot="prepend" />
                          </va-input>
                        </div>
                        <sp360-data-table id="tabelaServicos30dias" ref="tabelaSolicitacoes"
                            :apiMode="false"
                            :data="tableData.data"
                            :fields="tableFields"
                            :perPage="itemsPerPage[0].value"
                            :onEachSide="onEachSide"
                            :dataModeFilterableFields="dataModeFilterableFields"
                            :sortFunctions="sortFunctionsServ"
                            :filterInputShown="true"
                            :title="this.tituloTabela"
                        />
                    </div>
            </div>
        </sp-360-panel>
      </div>
  </div>
</template>

<script>
import SpMap from '@/components/maps/360-maps/SPMap.vue'
import _ from 'lodash'
import mapaDeCalor from '@/services/MapaDeCalor'
import MetodosGlobais from '@/utils/MetodosGlobais'
import Constantes from '@/utils/ConstantesGlobais'
import CorUtil from '@/utils/CorUtils'
import Multiselect from 'vue-multiselect'
import * as d3 from 'd3'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'

export default {
  name: 'table-and-mapa-solicitacoes',
  components: {
    SpMap,
    Multiselect,
    Sp360DataTable,
    Sp360Panel,
  },
  props: {
    filtro: {
      type: String,
      required: true,
      validator: value => {
        return ['sub', 'orgao'].includes(value)
      },
    },
  },
  data () {
    return {
      footerText: null,
      footerComplementar: null,
      termoBuscaSituacao: null,
      dadosFooter: [],
      indexTabela: 0,
      corteTemporal: [this.$t('mainDashboard.multiselect.ultimoMesFechado'), this.$t('mainDashboard.multiselect.ultimoSemestreFechado'), this.$t('mainDashboard.multiselect.ultimos30Dias'), this.$t('mainDashboard.multiselect.ultimos180Dias')],
      corteTemporalEscolhido: 'Último mês fechado',
      tituloDashboard: this.$t('mainDashboard.title'),
      tooltipOptions: {},
      tituloTabela: this.$t('mainDashboard.tituloTabelaSituacaoServico'),
      munAtual: this.$t('mainDashboard.general'),
      ultimoClickNomeSub: null,
      ultimoClickIdSub: 0,
      solicitacoes30: {},
      solicitacoes180: {},
      solicitacoesUltimoMes: {},
      solicitacoesUltimoSemestre: {},
      cores: {
        claro: '#f1f1fa',
        medio: '#9c9cd4',
        escuro: '#3b3b72',
      //   claro: CorUtil.getCorPorNomeSp360(CorUtil.VIOLETA_CLARO),
      //   medio: CorUtil.getCorPorNomeSp360(CorUtil.VIOLETA_MEDIO),
      //   escuro: CorUtil.getCorPorNomeSp360(CorUtil.VIOLETA_ESCURO),
      },
      itemsPerPage: [
        {
          value: 10, // Constantes.PARAMETROS_DASHBOARD.SP156.QTD_DE_LINHAS_TABELAS_SERVICO_POR_REGIAO,
        },
        {
          value: 10, // Constantes.PARAMETROS_DASHBOARD.SP156.QTD_DE_LINHAS_TABELAS_SERVICO_POR_REGIAO,
        },
      ],
      tableData: {
        'data': [],
      },
      tableFields: [
        {
          name: 'posicao',
          title: '#',
          titleClass: 'center aligned',
          dataClass: 'right aligned',
          width: '5%',
        },
        {
          name: '__slot:estoque',
          dataClass: 'action-slot',
          width: '5%',
        },
        {
          name: 'nomeServ',
          title: this.$t('mainDashboard.tableFields.servicos'),
          width: '50%',
        },
        {
          name: 'solicitacoesRecebidas',
          sortField: 'solicitacoesRecebidas',
          title: this.$t('mainDashboard.tableFields.recebidas'),
          callback: MetodosGlobais.thousandSeparator,
          width: '13%',
        },
        {
          name: 'finalizadas',
          sortField: 'finalizadas',
          title: this.$t('mainDashboard.tableFields.finalizadas'),
          callback: MetodosGlobais.thousandSeparator,
          width: '13%',
        },
        {
          name: 'tempoMedio',
          sortField: 'tempoMedio',
          title: this.$t('mainDashboard.tableFields.TMA'),
          callback: this.formatarNumeroDias,
          width: '13%',
        },
      ],
      onEachSide: 1,
      dataModeFilterableFields: ['nomeServ'],
      sortFunctionsServ: {
        'solicitacoesRecebidas': MetodosGlobais.ordenaTabela,
        'finalizadas': MetodosGlobais.ordenaTabela,
        'tempoMedio': MetodosGlobais.ordenaTabelaParseInt,
      },

    }
  },
  mounted () {
    this.criarLegenda()
    this.tooltipOptions = { content: this.$t('indisponivel'), placement: 'bottom' }
  },
  methods: {
    criarTextosDataIntervalo (dataI, dataF, tipo) {
      let dataInicio = MetodosGlobais.dateToJsonDateParts(dataI)
      let dataFim = MetodosGlobais.dateToJsonDateParts(dataF)
      if (tipo === 'fechado') { return ` (${MetodosGlobais.mapeiaMesAbreviacao(dataInicio.mes).abrev}/${dataInicio.ano})` } else if (tipo === 'completo') { return ` (${dataInicio.dia}/${dataInicio.mes}/${dataInicio.ano} a ${dataFim.dia}/${dataFim.mes}/${dataFim.ano})` } else { return ` (${MetodosGlobais.mapeiaMesAbreviacao(dataInicio.mes).abrev}/${dataInicio.ano} a ${MetodosGlobais.mapeiaMesAbreviacao(dataFim.mes).abrev}/${dataFim.ano})` }
    },

    buscaTermoSituacao: _.debounce(function (termoBusca) {
      this.filtraTermoBusca(termoBusca)
    }, 400),

    filtraTermoBusca (termoBusca) {
      if (!termoBusca) {
        this.termoBuscaSituacao = ''
        termoBusca = this.termoBuscaSituacao
      }
      let servicosFiltrados = []
      let dataSetEscolhido = this.getDadosSelecionado()
      let dados = this.buscarTopsPorRegiao(this.ultimoClickIdSub, dataSetEscolhido)

      if ((!Number.isNaN(parseInt(termoBusca))) && termoBusca != '') {
        dados = this.$refs.tabelaSolicitacoes.filterByNumber(dados, termoBusca)
      } else {
        dados = this.$refs.tabelaSolicitacoes.filterByString(dados, termoBusca)
      }

      dados = _.orderBy(dados, ['solicitacoesRecebidas'], ['desc'])

      this.$set(this.tableData, 'data', dados)
    },

    limparTermoBusca () {
      this.termoBuscaSituacao = ''
      this.filtraTermoBusca(this.termoBuscaSituacao)
    },

    updatesub (value) {
      this.corteTemporalEscolhido = value
      if (this.corteTemporalEscolhido === this.corteTemporal[2]) {
        this.updateDadosUltimos30Dias(this.solicitacoes30)
        this.updateFooterText(0)
      } else if (this.corteTemporalEscolhido === this.corteTemporal[3]) {
        this.updateDadosUltimos180Dias(this.solicitacoes180)
        this.updateFooterText(1)
      } else if (this.corteTemporalEscolhido === this.corteTemporal[0]) {
        this.updateDadosUltimoMesFechado(this.solicitacoesUltimoMes)
        this.updateFooterText(2)
      } else if (this.corteTemporalEscolhido === this.corteTemporal[1]) {
        this.updateDadosUltimoSemestreFechado(this.solicitacoesUltimoSemestre)
        this.updateFooterText(3)
      }
      this.limparTermoBusca()
    },
    getDadosSelecionado () {
      if (this.corteTemporalEscolhido === this.corteTemporal[2]) {
        return this.solicitacoes30.data
      } else if (this.corteTemporalEscolhido === this.corteTemporal[3]) {
        return this.solicitacoes180.data
      } else if (this.corteTemporalEscolhido === this.corteTemporal[0]) {
        return this.solicitacoesUltimoMes.data
      } else if (this.corteTemporalEscolhido === this.corteTemporal[1]) {
        return this.solicitacoesUltimoSemestre.data
      }
    },
    criarLegenda () {
      this.$refs.mapa.definirLegenda([this.cores.claro, this.cores.medio, this.cores.escuro],
        [this.$t('mainDashboard.legendaTitulo')])
    },
    filtrarPorRegiao (id) {
      let dados = this.solicitacoes30.data
      let idNum = MetodosGlobais.idSvgToNumeric(id)
      if (this.ultimoClickNomeSub != id) {
        let rgb = CorUtil.getCorPorNomeSp360(CorUtil.VERDE_MEDIO)
        this.$refs.mapa.limparClick(this.ultimoClickNomeSub)
        this.$refs.mapa.diminuirOpacidadeTodas()
        this.$refs.mapa.aumentarOpacidade(id)
        this.updateTable(idNum)
        this.ultimoClickNomeSub = id
        this.ultimoClickIdSub = idNum
        this.munAtual = dados[idNum].nome
      } else {
        this.$refs.mapa.limparClick(id)
        this.$refs.mapa.aumentarOpacidadeTodas()
        this.updateTable(0)
        this.ultimoClickNomeSub = null
        this.ultimoClickIdSub = 0
        this.munAtual = this.$t('mainDashboard.general')
      }
      this.filtraTermoBusca(this.termoBuscaSituacao)
    },
    formatarNumeroDias (x) {
      let unidade = x != 1 ? this.$t('mainDashboard.days') : this.$t('mainDashboard.day')
      let numeroFormatado = MetodosGlobais.thousandSeparator(x, '.', null)
      return (numeroFormatado + unidade)
    },
    buscarTopsPorRegiao (id, dados) {
      let newTableData = []
      let posicao = 0
      dados[id].servicos.forEach(element => {
        posicao++
        let newObj = {}
        newObj.posicao = posicao
        newObj.nomeServ = element.servico_desc
        newObj.solicitacoesAbertas = element.abertas
        newObj.solicitacoesRecebidas = element.recebidas
        newObj.taxaFechamento = MetodosGlobais.formataPercentual(element.finalizadas / element.total * 100)
        newObj.taxaCancelamento = MetodosGlobais.formataPercentual(element.canceladas / element.total * 100)
        newObj.tempoMedio = parseInt((element.media_atendimento_dias).toFixed(0))
        newObj.tempoMediano = (element.media_atendimento_dias).toFixed(0)
        newObj.finalizadas = element.finalizadas
        newObj.total = element.total
        newObj.estoque = '---'
        newObj.arrowUp = newObj.solicitacoesRecebidas >= newObj.finalizadas ? { class: 'red-arrow', title: this.$t('mainDashboard.crescimentoEstoque') } : false
        newObj.arrowDown = newObj.solicitacoesRecebidas < newObj.finalizadas ? { class: 'green-arrow', title: this.$t('mainDashboard.diminuicaoEstoque') } : false
        newTableData.push(newObj)
      })
      return newTableData
    },
    updateTable (id, paramDados) {
      if (!paramDados) { paramDados = this.getDadosSelecionado() }
      let dados = this.buscarTopsPorRegiao(id, paramDados)
      dados = _.orderBy(dados, ['solicitacoesRecebidas'], ['desc'])
      dados = dados.slice(0, dados.length/* Constantes.PARAMETROS_DASHBOARD.SP156.QTD_DE_LINHAS_TABELAS_SERVICO_POR_REGIAO */)
      this.$set(this.tableData, 'data', dados)
    },
    updateDadosUltimos180Dias (novosDados) {
      this.solicitacoes180 = novosDados
      let alterado = this.$t('mainDashboard.multiselect.ultimos180Dias') + this.criarTextosDataIntervalo(this.solicitacoes180.data[0].intervalo_inicio, this.solicitacoes180.data[0].intervalo_fim, 'completo')
      if (this.corteTemporalEscolhido === this.corteTemporal[3]) {
        this.pintarTodasRegioes(this.solicitacoes180.data)
        this.setNomesMapa()
        this.updateTable(this.ultimoClickIdSub, this.solicitacoes180.data)
        this.corteTemporalEscolhido = alterado
        this.alterarTituloTabela(alterado)
      }
      this.$set(this.corteTemporal, 3, alterado)
    },
    updateDadosUltimos30Dias (novosDados) {
      this.solicitacoes30 = novosDados
      let alterado = this.$t('mainDashboard.multiselect.ultimos30Dias') + this.criarTextosDataIntervalo(this.solicitacoes30.data[0].intervalo_inicio, this.solicitacoes30.data[0].intervalo_fim, 'completo')
      if (this.corteTemporalEscolhido === this.corteTemporal[2]) {
        this.pintarTodasRegioes(this.solicitacoes30.data)
        this.setNomesMapa()
        this.updateTable(this.ultimoClickIdSub, this.solicitacoes30.data)
        this.corteTemporalEscolhido = alterado
        this.alterarTituloTabela(alterado)
      }
      this.$set(this.corteTemporal, 2, alterado)
    },
    updateDadosUltimoMesFechado (novosDados) {
      this.solicitacoesUltimoMes = novosDados
      let alterado = this.$t('mainDashboard.multiselect.ultimoMesFechado') + this.criarTextosDataIntervalo(this.solicitacoesUltimoMes.data[0].intervalo_inicio, this.solicitacoesUltimoMes.data[0].intervalo_fim, 'fechado')
      if (this.corteTemporalEscolhido === this.corteTemporal[0]) {
        this.pintarTodasRegioes(this.solicitacoesUltimoMes.data)
        this.setNomesMapa()
        this.updateTable(this.ultimoClickIdSub, this.solicitacoesUltimoMes.data)
        this.corteTemporalEscolhido = alterado
        this.alterarTituloTabela(alterado)
      }
      this.$set(this.corteTemporal, 0, alterado)
    },
    updateDadosUltimoSemestreFechado (novosDados) {
      this.solicitacoesUltimoSemestre = novosDados
      let alterado = this.$t('mainDashboard.multiselect.ultimoSemestreFechado') + this.criarTextosDataIntervalo(this.solicitacoesUltimoSemestre.data[0].intervalo_inicio, this.solicitacoesUltimoSemestre.data[0].intervalo_fim)
      if (this.corteTemporalEscolhido === this.corteTemporal[1]) {
        this.pintarTodasRegioes(this.solicitacoesUltimoSemestre.data)
        this.setNomesMapa()
        this.updateTable(this.ultimoClickIdSub, this.solicitacoesUltimoSemestre.data)
        this.corteTemporalEscolhido = alterado
        this.alterarTituloTabela(alterado)
      }
      this.$set(this.corteTemporal, 1, alterado)
    },
    alterarTituloTabela (corte) {
      this.tituloTabela = this.$t('mainDashboard.tituloTabelaSituacaoServico') + ' - ' + corte
    },
    pintarTodasRegioes (data) {
      // Prepara os dados  e remove o Geral
      let dados = _.cloneDeep(data)
      _.remove(dados, (d) => { return d.id === 0 })

      // Calcula os pontos centrais ( medianas, quartis, ... )
      let pontosCentrais = MetodosGlobais.calculaPontosCentrais(dados, 'recebidas')

      // let colorScale = d3.scaleLog()
      //   .domain([dados[0].abertas, pontosCentrais.median, dados[dados.length - 1].abertas])
      //   .range([this.cores.claro, this.cores.medio, this.cores.escuro])

      let colorScale = d3.scaleLinear()
        // .domain([d3.extent(pontosCentrais.domain, (e) => { return e.abertas })].unshift(0))
        // .domain([dados[dados.length - 1].abertas, dados[0].abertas])
        .domain([0.1, dados[0].recebidas])
        .range([this.cores.claro, this.cores.escuro])
      dados.forEach(o => {
        let id = 'sub' + o.id
        this.$refs.mapa.pintarRegiao(id, colorScale(o.recebidas))
      })

      dados = _.orderBy(dados, ['recebidas'])

      this.$refs.mapa.setLegenda(dados[0].recebidas, dados[dados.length - 1].recebidas, this.$t('mainDashboard.textoEixoLegenda.numeroSolicitacoesRegiao'), 6)
      this.criarLegenda()
    },
    setNomesMapa () {
      var nomes = []
      _.forEach(this.solicitacoes30.data, function (o) { // gerar um ignorando a posicao 0, usar o reduce
        nomes.push({ nome: o.nome, id: o.id })
      })
    },
    setFooterText (resposta) {
      this.dadosFooter = resposta
      this.updateFooterText(0)
    },
    updateFooterText (corte) {
      let dados = this.dadosFooter[corte].data.data
      let abertas = MetodosGlobais.thousandSeparator(dados[0].total + dados[1].total, '.', null)
      let naoGeoRef = MetodosGlobais.thousandSeparator(dados[0].total, '.', null)
      this.footerTabelaMapa = this.$t('mainDashboard.footerSolicitacoesMunicipio', { abertas: abertas, nao_georef: naoGeoRef })
    },
  },
}
</script>
<style lang="scss">
    #divFiltroTempo {
      padding-bottom: 15px;
    }
</style>
<style lang="scss" scoped>
  @media (min-width: 1001px) {
      #mapaSP{
          width: 35%;
      }

      #tabelaSolicitacoesRegiao{
          width: 65%;
      }

      #flex-box{
        display: flex;
      }
  }
  @media (max-width: 1000px) {
      #mapaSP{
          width: 35%;
      }

      #tabelaSolicitacoesRegiao{
          width: 65%;
      }

      #flex-box{
        display: flex;
      }
  }

  .red-arrow{
    color: $theme-red;
  }

  .green-arrow{
    color: $vue-green;
  }

  .blue-arrow{
    color: $theme-blue;
  }
</style>
